const field = document.getElementsByTagName('html')[0];
const topfield = field.getBoundingClientRect().top;
let handleElement;
let dragElement;

let drag = false;

const startPos = {
  x: '',
  y: '',
};
const objectPos = {
  x: 0,
  y: 0,
};

const handleMousedown = (element) => {
  const pos = dragElement.getBoundingClientRect();
  drag = true;
  startPos.x = element.clientX;
  startPos.y = element.clientY;
  objectPos.x = pos.left;
  objectPos.y = pos.top;
};

const handleMouseup = () => {
  drag = false;
};

const getPosition = (value) => `${value}px`;

const handleMousemove = (element) => {
  if (drag === true && dragElement !== null) {
    dragElement.style.right = 'auto';
    if (objectPos.x + (element.clientX - startPos.x) < 0) {
      dragElement.style.left = 0;
    } else if (
      objectPos.x + (element.clientX - startPos.x) + dragElement.offsetWidth >
      field.offsetWidth
    ) {
      dragElement.style.left = getPosition(
        field.offsetWidth - dragElement.offsetWidth,
      );
    } else {
      dragElement.style.left = getPosition(
        objectPos.x + (element.clientX - startPos.x),
      );
    }

    if (objectPos.y + (element.clientY - startPos.y - topfield) < 0) {
      dragElement.style.top = 0;
    } else {
      dragElement.style.top = getPosition(
        objectPos.y + (element.clientY - startPos.y - topfield),
      );
    }
  }
};

export const addDragListener = (dragElementId, handleElementId) => {
  handleElement = document.getElementById(handleElementId);
  dragElement = document.getElementById(dragElementId);

  handleElement.addEventListener('mousedown', handleMousedown);

  handleElement.addEventListener('mouseup', handleMouseup);

  field.addEventListener('mousemove', handleMousemove);
};

export const removeDragListener = (handleElementId) => {
  handleElement = document.getElementById(handleElementId);

  handleElement.removeEventListener('mousedown', handleMousedown);

  handleElement.removeEventListener('mouseup', handleMouseup);

  field.removeEventListener('mousemove', handleMousemove);
};
